module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Lifelong Health & Fitness","short_name":"Lifelong H&F","start_url":"/","background_color":"#fbfefa","theme_color":"#540d6e","display":"minimal-ui","icon":"src/images/brand/icon/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"fc12280d825519d349cc947bdce297fa"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
